
























































































import { Component, Vue } from "vue-property-decorator";
import { State, Action } from "vuex-class";
import _ from "lodash";
// import { firstDayInPrevMonth, formatDateTime } from "@/global.ts";
import GlobalMixins from "@/global.mixin";
import {importExportApi} from "../../../services/api/importexport.api";
import { locationApi } from "../../../services/api/locations.api";

@Component({
  mixins: [GlobalMixins],
  components: {  }
})
export default class Locations extends Vue {
  @State("locations") locationsState: any;

  @Action("getLocations") getLocations: any;
  @Action("saveLocation") saveLocation: any;
  @Action("deleteLocation") deleteLocation: any;

  @State("sites") sitesState: any;
  @Action("getSites") getSites: any;

  snackbar = false;
  snacktext = "";
  loader = false;
  search = "";

  sitesSearchTerm = "";
  sitesSearched: string[] = [];

  editingDialog = false;
  isNewLocation = false;
  defaultItem = {
    locationId: 0,
    name: "",
    description: "",
    siteId: -1,
    isInUse: false,
  };
  editedItem = Object.assign({}, this.defaultItem);
  editedIndex = -1;
  dollySearchTerm = "";
  localDollies = [];

  // Upload related properties
  uploadDialog = false;
  uploadDialogTitle = "";
  uploadDialogText = "";
  loading = false;

  rowsPerPageItems = [10, 25, 50, 100, 200, { text: "All", value: -1 }];

  pagination = {
    sortBy: "name",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("locations-rowsPerPage") ?
                        parseInt(this.$cookies.get("locations-rowsPerPage"), 10) : 25
  };

  serversideSearch = _.debounce(() => {
    this.updatePagination(this.pagination);
  }, 300);

  // tslint:disable:max-line-length
  getHeaders() { return [
    { text: "#", value: "locationId", width: "1%", align: "left", sortable: true},
    { text: this.$t("LOCATIONS_TABLE_HEADER_SITE"), value: "site.code", width: "1%", align: "left", sortable: true },
    { text: this.$t("LOCATIONS_TABLE_HEADER_NAME"), value: "name", width: "1%", align: "left", sortable: true },
    { text: this.$t("LOCATIONS_TABLE_HEADER_DESCRIPTION"), value: "description", width: "1%", align: "left", sortable: true },
    // { text: this.$t("TABLE_ACTIONS"), value: "", sortable: false,  }
  ];
  }
  async created() {
    await this.getSites();
    this.searchSites(null);
  }

  searchSites(e) {
    if (!this.sitesSearchTerm) {
      this.sitesSearched = this.sitesState.sites;
      return;
    }

    this.sitesSearched = this.sitesState.sites.filter((item) => {
      return item.code.indexOf(this.sitesSearchTerm.toUpperCase()) > -1 ||
             item.description.indexOf(this.sitesSearchTerm.toUpperCase()) > -1;
    });
  }

  reload() {
    this.updatePagination(this.pagination);
  }

  changeSort(column, sortable) {
    if (!sortable) {
      return;
    }

    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
    this.updatePagination(this.pagination);
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("locations-rowsPerPage", pagination.rowsPerPage);

    const searchexpression = this.search.trim();
    const x = searchexpression.split(" ");
    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      searchString: x,
    };
    this.getLocations(page);
  }

  save() {
    this.saveLocation({
      data: JSON.stringify(this.editedItem),
      index: this.editedIndex
    })
      .then(res => {
        this.close();
      })
      .catch(res => {
        // handle....
        // this.close();
      });
  }

  close() {
    this.editingDialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
  }

  editItem(item) {
    this.isNewLocation = false;
    this.editedIndex = this.locationsState.locations.indexOf(item);
    this.editedItem = Object.assign({}, item);

    this.editingDialog = true;
  }

  deleteItem(item) {
    const index = this.locationsState.locations.indexOf(item);
    if (confirm(this.$t("LOCATION_DELETE_CONFIRM") as string)) {
      this.deleteLocation({ id: item.locationId, index });
    }
  }

  // Download methods
  downloadLocationsData() {
    importExportApi.downloadLocationExport({}, "lokacio-export.xlsx");
  }

  // Upload methods
  onPickFile() {
    (this.$refs.fileInput as HTMLInputElement).click();
  }

  selectFile(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    this.loading = true;

    locationApi.upload(file)
      .then(res => {
        this.loading = false;
        if (res.data.status === 1) {
          // success
          this.uploadDialogTitle = "Sikeres betöltés!";
          this.uploadDialogText = res.data.msg;
        } else if (res.data.status === 3) {
          // validation errors
          this.uploadDialogTitle = "Hiba van az adatokban!";
          this.uploadDialogText = res.data.errors.join("<br>");
        } else {
          this.uploadDialogTitle = "Error";
          this.uploadDialogText = res.data.msg || "Unknown error occurred";
        }
        this.uploadDialog = true;
        // Refresh the data after successful upload
        if (res.data.status === 1) {
          this.updatePagination(this.pagination);
        }
      })
      .catch(error => {
        this.loading = false;
        this.uploadDialogTitle = "Unexpected Response!";
        this.uploadDialogText = JSON.stringify(error);
        this.uploadDialog = true;
        console.error("Upload failed:", error);
      });

    // Clear the file input so the same file can be selected again
    event.target.value = "";
  }
}
